import { assign } from 'xstate';
import { SetPageEvent } from './events';
import { type Context } from './types';

export const assignCurrentPage = assign({
  currentPage: ({ event }) => event.payload.page,
});

export const createPageGuard = (params: { page: Context['currentPage'] }) => {
  return ({ event }: { event: SetPageEvent }) =>
    event.type === 'ON_SET_PAGE' && event.payload.page === params.page;
};
